import { useState } from "react";
import ReactModal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentRow, MyModalContentSelectInput, MyModalContentSelectInputOption, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";

var MonitorApi = require("monitor-api");


export default function VlpCreate({ vvList, linieList, prodList, vvLinProdInstance, reloadData }) {

    const [modalState, setModalState] = useState(false);
    const [newVlp, setNewVlp] = useState({});

    const openModal = () => {
        setModalState(true);
        setNewVlp(new MonitorApi.ApiVertraglinieproduktCreate());
    }

    const closeModal = () => {
        setModalState(false);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const fillInstance = event => {
        setNewVlp(pre => ({ ...pre, [event.target.id]: event.target.value }))
    }

    const saving = (event) => {
        event.preventDefault();
        console.log("save", newVlp)
        vvLinProdInstance.postAddNewVlp(newVlp, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                alert(`Neue Zuordnung ${data.name} erstellt unter der Id: ${data.id}`);
                closeModal();
                reloadData();
            }
        });
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neue Zuordnung</MyNewButton>

            <ReactModal isOpen={modalState} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saving}>
                    <h3>Erstellen einer neuen Zuordnung</h3>

                    <MyModalContentRow>
                        <label>Verkehrsvertrag:
                            <MyModalContentSelectInput id="vvId" onChange={fillInstance} required>
                                <MyModalContentSelectInputOption defaultValue={true} hidden={true} value="">--Verkehrsvertrag--</MyModalContentSelectInputOption>
                                {vvList.map(vv =>
                                    <MyModalContentSelectInputOption key={vv.id} value={vv.id}>{vv.vertrag}</MyModalContentSelectInputOption>
                                )}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Linie:
                            <MyModalContentSelectInput id="linieId" onChange={fillInstance} required>
                                <MyModalContentSelectInputOption defaultValue={true} hidden={true} value="">--Linie--</MyModalContentSelectInputOption>
                                {linieList.map(l =>
                                    <MyModalContentSelectInputOption key={l.id} value={l.id}>{l.linie}</MyModalContentSelectInputOption>
                                )}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Produkt:
                            <MyModalContentSelectInput id="prodId" onChange={fillInstance} required>
                                <MyModalContentSelectInputOption defaultValue={true} hidden={true} value="">--Produkt--</MyModalContentSelectInputOption>
                                {prodList.map(p =>
                                    <MyModalContentSelectInputOption key={p.id} value={p.id}>{p.produkt}</MyModalContentSelectInputOption>
                                )}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>

                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn:
                            <MyModalContentDateInput
                                id="gueltigVon"
                                onChange={fillInstance}
                                max={newVlp.gueltigBis ? newVlp.gueltigBis : '3000-31-12'} required
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Gültigkeitsende (optional):
                            <MyModalContentDateInput
                                id="gueltigBis"
                                onChange={fillInstance}
                                min={newVlp.gueltigVon ? newVlp.gueltigVon : '1800-01-01'}
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput name="kommentar" onChange={fillInstance} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </ReactModal>
        </div>

    )
}